import { Component } from '@angular/core';

@Component({
  selector: 'inline-spinner',
  standalone: true,
  imports: [],
  templateUrl: './inline-spinner.component.html',
  styleUrl: './inline-spinner.component.scss'
})
export class InlineSpinnerComponent {

}
